"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var react_1 = __importDefault(require("react"));
var context_1 = require("../../../context");
var FormControl_1 = __importDefault(require("../../FormControl"));
var Input_1 = __importStar(require("../../Input"));
var EmailInput = function () {
    var trans = context_1.useSemantics().trans;
    var errors = formik_1.useFormikContext().errors;
    return (react_1.default.createElement(FormControl_1.default, { errors: errors.email, dusk: "email-field", label: trans('optiiva::labels.email-address') },
        react_1.default.createElement(Input_1.default, { dusk: "email", name: "email", type: Input_1.InputType.email, maxLength: 250 })));
};
exports.default = EmailInput;
//# sourceMappingURL=EmailInput.js.map